import { FC } from 'react';

import ArrowRight from '@/assets/icons/ArrowRight';
import Pill from '@/components/UI/Pill/Pill';
import { Conflict, ConflictElement } from '@/types/Conflicten';

import { geefOpvolgendeBijzonderheidscodesVoorConflict } from '../../../utils/conflict';

import styles from '../Conflict.module.css';

/** Toont, als er ergens later in dezelfde werklijn nog inzetten volgen met een bijzonderheidscode,
 * een pijltje-chip rechts van het materieel-label:
 * - exact 1 unieke latere code → toon die code zelf (bv. '→ SDV')
 * - meer dan 1 unieke latere code → toon een samengevoegde '→ +N'-chip in `compact` modus (de
 *   plank-rij), of alle codes los naast elkaar in de niet-compacte modus (het detailpaneel, waar
 *   ze allemaal terug te zien zijn).
 */
const ConflictBijzonderheidscodeGroup: FC<{
  conflict: Conflict;
  huidigElement: ConflictElement | undefined;
  testid?: string;
  compact?: boolean;
}> = ({ conflict, huidigElement, testid, compact = false }) => {
  const opvolgendeCodes = geefOpvolgendeBijzonderheidscodesVoorConflict(conflict, huidigElement);

  if (opvolgendeCodes.length === 0) return null;

  if (compact && opvolgendeCodes.length > 1) {
    return (
      <div className={styles.opvolgendeBijzonderheidscodeGroupStyle} data-testid={testid}>
        <Pill
          variant='info'
          size='small'
          icon={ArrowRight}
          testid={testid && `${testid}-+${opvolgendeCodes.length}`}
          className={styles.bijzonderheidscodeTagStyle}
          ariaLabel={`Later deze werklijn: ${opvolgendeCodes.length} bijzonderheidscodes, zie detailpaneel`}
        >
          +{opvolgendeCodes.length}
        </Pill>
      </div>
    );
  }

  return (
    <div className={styles.opvolgendeBijzonderheidscodeGroupStyle} data-testid={testid}>
      {opvolgendeCodes.map((code) => (
        <Pill
          key={code}
          variant='info'
          size='small'
          icon={ArrowRight}
          testid={testid && `${testid}-${code}`}
          className={styles.bijzonderheidscodeTagStyle}
          ariaLabel={`Later deze werklijn: ${code}`}
        >
          {code}
        </Pill>
      ))}
    </div>
  );
};
export default ConflictBijzonderheidscodeGroup;
